import * as CONST from 'Reducers/Countries/const'
import * as CAMPAIGN_CONST from 'Reducers/Campaigns/const'

const initState = {
  countriesList: [],
  // A hash map with the key being the country id
  countries: {},
}

export function countries(state = initState, action) {
  switch (action.type) {
    case CONST.GET_COUNTRIES_SUCCESS:
      return {
        ...state,
        countriesList: action.payload.countries,
      }

    case CAMPAIGN_CONST.GET_CAMPAIGN_RESULTS_SUCCESS: {
      return {
        ...state,
        countries: {
          ...state.countries,
          ...(() => {
            var cityPlans = action.result.data.campaign.cityPlans.nodes
            var subObject = {}
            cityPlans.forEach(cityPlan => {
              subObject[cityPlan.city.country.id] = Object.assign(
                {},
                state[cityPlan.city.country.id],
                {
                  id: cityPlan.city.country.id,
                  name: cityPlan.city.country.name,
                  code: cityPlan.city.country.code,
                },
              )
            })
            return subObject
          })(),
        },
      }
    }

    default:
      return state
  }
}
